import { render, staticRenderFns } from "./MixPicklDetails.vue?vue&type=template&id=3816b953&"
import script from "./MixPicklDetails.vue?vue&type=script&lang=js&"
export * from "./MixPicklDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports